import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a5ed9f5c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a5ed9f5c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ed9f5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5ed9f5c')) {
      api.createRecord('a5ed9f5c', component.options)
    } else {
      api.reload('a5ed9f5c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a5ed9f5c&scoped=true", function () {
      api.rerender('a5ed9f5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintenance/service/index.vue"
export default component.exports